import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import { BlockToggle } from "./UsersList";
import { defaultProfile, togleA, togleB, view } from "../assets/img";
import { NavLink, useNavigate } from "react-router-dom";
import common from "../assets/css/common.module.css";
import { Loader } from "../../components/Loader";
import { nextArow, swipetestleft } from "../../assets/images";
import { postData1 } from "../../services";
import { Pagination } from "../Common";

const sortIcon = {
  asc: "↑",
  desc: "↓",
};

export const SparepareAssocirese = () => {
  const navigate = useNavigate();
  const [newAdslistData, setNewAdsListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "id", // Default sorting by product ID
    direction: "asc",
  });
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [query, setQuery] = useState(null)
  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  useEffect(() => {
    const config = { post_type: 3, _page: currPage, _limit: itemsPerPage };

    (async () => {
      setLoader(true); // Start loader
      try {
        const res = await postData1("admin/product_list/", config, true, true);

        const sortedData = [...res?.data?.data].sort((a, b) => {
          const aValue = a[sortConfig.key];
          const bValue = b[sortConfig.key];

          if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
          if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
          return 0;
        });

        setNewAdsListData(sortedData);
        setPaging({
          total: res?.data?.total,
          total_pages: res?.data?.total_pages,
        });
      } catch (error) {
        console.error("Error fetching product list:", error);
        // Optionally handle error UI here
      } finally {
        setLoader(false); // Always stop loader
      }
    })();
  }, [currPage, sortConfig, itemsPerPage]);


  // useEffect(() => {
  //   const config = { post_type: 3, _page: currPage, _limit: itemsPerPage };
  //   (async () => {
  //     const res = await postData1("admin/product_list/", config, true, true);
  //     const sortedData = [...res?.data?.data].sort((a, b) => {
  //       const aValue = a[sortConfig.key];
  //       const bValue = b[sortConfig.key];
  //       if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
  //       if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
  //       return 0;
  //     });
  //     setNewAdsListData(sortedData);
  //     setPaging({
  //       total: res?.data?.total,
  //       total_pages: res?.data?.total_pages,
  //     });
  //     setLoader(false);
  //   })();
  // }, [currPage, sortConfig, itemsPerPage]);

  const handleView = (e, data) => {
    navigate("/admin/manageneweqip/viewuser/", {
      state: {
        productId: data.id
      }
    });
  };

  // Fixed filter function
  const filteredData = newAdslistData.filter((item) => {
    // Safely handle query being null/undefined
    const q = query ? query.trim().toLowerCase() : "";
    if (!q) return true;  // Show all items when query is empty

    return (
      (item?.equip_name || "").toLowerCase().includes(q) ||
      (item?.brand || "").toLowerCase().includes(q) ||
      // (item?.equipname_list || []).some(
      //   (cat) => (cat || "").toLowerCase().includes(q)
      // ) ||
      (item?.category_list || "").toLowerCase().includes(q) ||
      (item?.speciality_name || "").toLowerCase().includes(q)
    );
  });
  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>Spare and Accessories</h1>
        <div className="w-[40%] flex items-center border border-[#019c89] rounded-md px-3 py-1 shadow-sm ">
          <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
          <input
            type="text"
            placeholder="Search by name, brand, category, speciality..."
            className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSort("id")}>
            PRODUCT ID {sortConfig.key === "id" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("seller_name")}>
            Name {sortConfig.key === "seller_name" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("seller_firstname")}>
            OWNER {sortConfig.key === "seller_firstname" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("equip_name")}>
            EQUIP NAME {sortConfig.key === "equip_name" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("equipname_list")}>
            CATEGORY {sortConfig.key === "equipname_list" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("speciality_name")}>
            SPECIALITY {sortConfig.key === "speciality_name" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("asking_price")}>
            ASK PRICE {sortConfig.key === "asking_price" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("brand")}>
            BRAND {sortConfig.key === "brand" && sortIcon[sortConfig.direction]}
          </span>
          {/* <span onClick={() => handleSort("warranty")}>
            WARRANTY {sortConfig.key === "warranty" && sortIcon[sortConfig.direction]}
          </span> */}
          <span onClick={() => handleSort("change_owner")}>
            CHANGE OWNER {sortConfig.key === "change_owner" && sortIcon[sortConfig.direction]}
          </span>
          <span onClick={() => handleSort("address")}>
            CITY {sortConfig.key === "address" && sortIcon[sortConfig.direction]}
          </span>
          <span >
            PRODUCT DES
          </span>
          <span onClick={() => handleSort("product_status")}>
            STATUS {sortConfig.key === "product_status" && sortIcon[sortConfig.direction]}
          </span>
          <span>DETAIL</span>
        </div>

        {/* {filteredData.map((data, index) => {
          return (
            <div className={styles.itemData} key={index}>
              <span>{data?.id}</span>
              <span>{data?.seller_firstname}</span>
              <span>{data?.equip_name}</span>
              <span>{data?.equipname_list[0]}</span>
              <span>{data?.speciality_name?.slice(0, 10)}</span>
              <span>{parseFloat(data?.asking_price).toFixed(2)}</span>
              <span>{data?.brand}</span>
              <span>{data?.warranty === 1 ? "Yes" : "No"}</span>
              <span>{data?.address?.slice(0, 20)}</span>
              <span>
                <span className={common.customStyle}>
                  {data?.product_status === 1
                    ? "OPEN"
                    : data?.product_status === 2
                      ? "LOCK"
                      : data?.product_status === 3
                        ? "Selled"
                        : data?.product_status === 4
                          ? "PENDING"
                          : ""}
                </span>
              </span>
              <span
                style={{ cursor: "pointer" }}
                onClick={(e) => handleView(e, data)}
              >
                View
              </span>
            </div>
          );
        })} */}
        {filteredData.length > 0 ? (
          filteredData.map((data, index) => {
            return (
              <div className={styles.itemData} key={index}>
                <span>{data?.id}</span>
                <span>{data?.seller_name}</span>
                <span>{data?.seller_firstname}</span>
                <span
                  onClick={() => window.open(`https://www.equipmedy.com/${data?.slug}`, '_blank', 'noopener,noreferrer')}
                  className="cursor-pointer"
                >{data?.equip_name}</span>
                <span>{data?.category_list}</span>
                <span>{data?.speciality_name?.slice(0, 10)}</span>
                <span>{parseFloat(data?.asking_price).toFixed(2)}</span>
                <span>{data?.brand}</span>
                {/* <span>{data?.warranty === 1 ? "Yes" : "No"}</span> */}
                <span>{data?.address?.slice(0, 20)}</span>
                <span className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                  onClick={() => navigate("/admin/change-owner/", { state: { data: data } })}
                >Change</span>
                <span
                  className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                  onClick={() => navigate("/admin/product-description/", {
                    state: {
                      data: data,
                      type: "product"
                    }
                  })}
                >Add</span>
                <span>
                  <span className={common.customStyle}>
                    {data?.product_status === 1
                      ? "OPEN"
                      : data?.product_status === 2
                        ? "LOCK"
                        : data?.product_status === 3
                          ? "Selled"
                          : data?.product_status === 4
                            ? "PENDING"
                            : ""}
                  </span>
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleView(e, data)}
                >
                  View
                </span>
              </div>
            );
          })
        ) : (
          <div className="flex items-center justify-center text-gray-500 py-4">
            <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
            <span>No results found</span>
          </div>
        )}

      </div>
      <Pagination
        total={paging?.total}
        perPage={itemsPerPage}
        setPerPage={setItemsPerPage}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setCurrPage={setCurrPage} // Add this prop
      />

      {loader && <Loader />}
    </section>
  );
};

// export const UsedEquipList = () => {
//   const navigate = useNavigate();
//   const [usedAdslistData, setUsedAdsListData] = useState([]);
//   const [loader, setLoader] = useState(true);
//   const [currPage, setCurrPage] = useState(1);
//   const [paging, setPaging] = useState({});
//   const [prevPage, setPrevPage] = useState(1);
//   const [sortConfig, setSortConfig] = useState({
//     key: "id", // Default sorting by product ID
//     direction: "asc",
//   });

//   const updatePage = (e) => {
//     let name = e.currentTarget.name;
//     if (name === "prev") {
//       setCurrPage(currPage === 1 ? 1 : currPage - 1);
//       setPrevPage(currPage);
//     } else if (name === "next") {
//       setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
//       setPrevPage(currPage);
//     } else {
//       setCurrPage(parseInt(e.currentTarget.innerHTML));
//     }
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   const handleSort = (key) => {
//     let direction = "asc";
//     if (sortConfig.key === key && sortConfig.direction === "asc") {
//       direction = "desc";
//     }
//     setSortConfig({ key, direction });
//   };

//   useEffect(() => {
//     const config = { post_type: 1, _page: currPage, _limit: 8 };
//     (async () => {
//       const res = await postData1("admin/product_list/", config, true, true);
//       const sortedData = [...res?.data?.data].sort((a, b) => {
//         const aValue = a[sortConfig.key];
//         const bValue = b[sortConfig.key];
//         if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
//         if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
//         return 0;
//       });
//       setUsedAdsListData(sortedData);
//       setPaging({
//         total: res?.data?.total,
//         total_pages: res?.data?.total_pages,
//       });
//       setLoader(false);
//     })();
//   }, [currPage, sortConfig]);

//   const handleView = (e, data) => {
//     navigate("/admin/manageneweqip/viewuser/", { state: data });
//   };

//   return (
//     <section className={styles.userListCont}>
//       <div className={styles.listHead}>
//         <h1>PREOWNED EQUIPMENTdd</h1>
//       </div>
//       <div className={styles.dataItems}>
//         <div className={styles.itemHead}>
//           <span onClick={() => handleSort("id")}>
//             PRODUCT ID {sortConfig.key === "id" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("seller_firstname")}>
//             OWNER {sortConfig.key === "seller_firstname" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("equip_name")}>
//             EQUIP NAME {sortConfig.key === "equip_name" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("equipname_list")}>
//             CATEGORY {sortConfig.key === "equipname_list" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("speciality_name")}>
//             SPECIALITY {sortConfig.key === "speciality_name" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("asking_price")}>
//             ASK PRICE {sortConfig.key === "asking_price" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("brand")}>
//             BRAND {sortConfig.key === "brand" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("warranty")}>
//             WARRANTY {sortConfig.key === "warranty" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("address")}>
//             CITY {sortConfig.key === "address" && sortIcon[sortConfig.direction]}
//           </span>
//           <span onClick={() => handleSort("product_status")}>
//             STATUS {sortConfig.key === "product_status" && sortIcon[sortConfig.direction]}
//           </span>
//           <span>DETAIL</span>
//         </div>

//         {usedAdslistData.map((data, index) => {
//           return (
//             <div className={styles.itemData} key={index}>
//               <span>{data?.id}</span>
//               <span>{data?.seller_firstname}</span>
//               <span>{data?.equip_name}</span>
//               <span>{data?.equipname_list[0]}</span>
//               <span>{data?.speciality_name?.slice(0, 10)}</span>
//               <span>{parseFloat(data?.asking_price).toFixed(2)}</span>
//               <span>{data?.brand}</span>
//               <span>{data?.warranty === 1 ? "Yes" : "No"}</span>
//               <span>{data?.address?.slice(0, 20)}</span>
//               <span>
//                 <span className={common.customStyle}>
//                   {data?.product_status === 1
//                     ? "OPEN"
//                     : data?.product_status === 2
//                       ? "LOCK"
//                       : data?.product_status === 3
//                         ? "Selled"
//                         : data?.product_status === 4
//                           ? "PENDING"
//                           : ""}
//                 </span>
//               </span>
//               <span
//                 style={{ cursor: "pointer" }}
//                 onClick={(e) => handleView(e, data)}
//               >
//                 View
//               </span>
//             </div>
//           );
//         })}
//       </div>
//       <Pagination
//         total={paging?.total}
//         perPage={8}
//         currPage={currPage}
//         prevPage={prevPage}
//         tPage={paging?.total_pages}
//         updatePage={updatePage}
//       />

//       {loader && <Loader />}
//     </section>
//   );
// };
